import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard'
import Walldash from '@/components/Walldash'
import Login from '@/components/Login'
import SalesPage from '../components/SalesPage'
import References from '@/components/References/Index'
import Diagnostics from '@/components/Diagnostics/Index'
import AnalyticsPage from '../pages/analytics/AnalyticsPage'
import InvoicesPage from '../pages/analytics/InvoicesPage'
import InvoicesListPage from '../pages/analytics/InvoicesListPage'
import InvoicePage from '../pages/analytics/InvoicePage'
import AnalyticsOverviewPage from '../pages/analytics/AnalyticsOverviewPage'
import CasesPage from '../pages/cases/CasesPage'
import CasePage from '../pages/cases/CasePage'
import CasesIndexPage from '../pages/cases/CasesIndexPage'
import CaseIndexPage from '../pages/cases/CaseIndexPage'
import CaseServicesPage from '../pages/cases/CaseServicesPage'
import Page404 from '../pages/Page404'

const uuidRegex = "([0-9a-fA-F]{8}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{4}\-[0-9a-fA-F]{12})";

Vue.use(Router);

function isUserLoggedIn() {
  return !!localStorage.getItem('token')
}

function userShouldBeAnonymous(from, to, next) {
  if (isUserLoggedIn()) {
    next({name: 'Dashboard'})
  }
  next()
}

function userShouldBeLoggedIn(store, from, to, next, afterLoginCheck = (from, to, next) => {
  next()
}) {
  if (!isUserLoggedIn()) {
    next({name: 'Login'})
  } else {
    afterLoginCheck(from, to, next)
  }
}

export function createRouter(store) {
  return new Router({
    routes: [
      {
        path: '/',
        component: Dashboard,
        beforeEnter(to, from, next) {
          next('/dashboard')
        }
      },
      {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard,
        beforeEnter(to, from, next) {
          return userShouldBeLoggedIn(store, from, to, next)
        }
      },
      {
        path: '/sales',
        name: 'Sales',
        component: SalesPage,
        beforeEnter(to, from, next) {
          return userShouldBeLoggedIn(store, from, to, next)
        }
      },
      {
        path: '/performance',
        name: 'Performance',
        component: Diagnostics,
        beforeEnter(to, from, next) {
          return userShouldBeLoggedIn(store, from, to, next)
        }
      },
      {
        path: '/reference',
        name: 'Reference',
        component: References,
        beforeEnter(to, from, next) {
          return userShouldBeLoggedIn(store, from, to, next)
        }
      },
      {
        path: '/walldash',
        name: 'Walldash',
        component: Walldash,
        beforeEnter(to, from, next) {
          return userShouldBeLoggedIn(store, from, to, next)
        }
      },
      {
        path: '/analytics',
        name: 'Analytics',
        component: AnalyticsPage,
        beforeEnter(to, from, next) {
          return userShouldBeLoggedIn(store, from, to, next)
        },
        children: [
          {
            path: `invoices`,
            name: 'InvoicesPage',
            component: InvoicesPage,
            children: [
              {
                path: `:invoiceId`,
                name: 'InvoicePage',
                component: InvoicePage,
              },
              {
                path: '',
                name: 'InvoicesListPage',
                component: InvoicesListPage
              },
            ]
          },
          {
            path: '',
            name: 'AnalyticsOverviewPage',
            component: AnalyticsOverviewPage,
            beforeEnter(to, from, next) {
              if (!to.query.filter) { // if filter not set, set it value from store
                const filter = store.state.analytics.filter;
                const filterAsString = JSON.stringify(filter);
                next({
                    name: 'AnalyticsOverviewPage',
                    query: {
                      filter: filterAsString
                    }
                  }
                )
              } else {
                // if filter value is set - push it to store
                const currentFilter = store.state.analytics.filter;
                const filterFromQueryAsString = to.query.filter;
                const filterFromQuery = JSON.parse(filterFromQueryAsString);
                store.dispatch('changeAnalyticsFilter', filterFromQuery);

                next()
              }
            }
          },
        ]
      },
      {
        path: '/cases',
        name: 'Cases',
        component: CasesPage,
        beforeEnter(to, from, next) {
          return userShouldBeLoggedIn(store, from, to, next)
        },
        children: [
          {
            path: `:caseId${uuidRegex}`,
            name: 'CasePage',
            component: CasePage,
            children: [
              {
                path: 'services',
                name: 'CaseServicesPage',
                component: CaseServicesPage
              },
              {
                path: '',
                name: 'CaseIndexPage',
                component: CaseIndexPage
              },
            ]
          },
          {
            path: '',
            name: 'CasesIndexPage',
            component: CasesIndexPage
          },
        ]
      },
      {
        path: '/login',
        name: 'Login',
        component: Login,
        beforeEnter(to, from, next) {
          userShouldBeAnonymous(to, from, next)
        }
      },
      {
        path: '*',
        name: 'NotFound',
        component: Page404
      }
    ]
  });
}



// WEBPACK FOOTER //
// ./src/router/index.js